import React from "react";
import { render } from "react-dom";
import { classNamePrefix as prefixCt } from "@/utils/common";
import {
  DEFAULT_LANGUAGE,
  DEFAULT_THEME,
  DEFAULT_TITLE,
} from "@/schema/citadel-schema/nodes/code_block";
import CodeViewer from "./viewer";
import { mainScript, modeScripts, extraScrpts } from "./config";
import "./index.less";

const loadCodeScript = (languages, onlyLoadNeedFiles = false) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = mainScript;
    script.onload = () => {
      Object.keys(modeScripts).forEach((lang) => {
        if (languages.has(lang) || !onlyLoadNeedFiles) {
          const newScript = document.createElement("script");
          newScript.src = modeScripts[lang];
          document.head.appendChild(newScript);
        }
      });
      extraScrpts.forEach((p) => {
        const newScript = document.createElement("script");
        newScript.src = p;
        document.head.appendChild(newScript);
      });
      setTimeout(() => {
        resolve("ok");
      }, 100);
    };
    document.head.appendChild(script);
  });
};

export default class codeRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("code")}`;
    this.config = config;
  }

  preprocess = async ($container) => {
    if (
      !(window as any).CodeMirror &&
      $container.querySelector(this.fragmentCls)
    ) {
      const languages = new Set();
      Array.from($container.querySelectorAll(this.fragmentCls)).forEach(
        (node: HTMLElement) => {
          if (node.getAttribute("data-language")) {
            languages.add(node.getAttribute("data-language"));
          }
        }
      );
      await loadCodeScript(languages, this.config.onlyLoadNeedFiles);
    }
  };

  fragmentRender = (node: HTMLElement) => {
    const codeNode = node.querySelector("code");
    if (!codeNode) return;

    const {
      language = DEFAULT_LANGUAGE,
      theme = DEFAULT_THEME,
      title = DEFAULT_TITLE,
    } = node.dataset;
    const isExpand = node.getAttribute("data-expand") !== "false";

    const data = {
      language,
      theme,
      title,
      isExpand,
      value: codeNode.textContent,
    };
    node.innerHTML = "";
    render(<CodeViewer {...data} />, node);

    // 清空data属性
    const attrs = [
      "data-language",
      "data-theme",
      "data-title",
      "data-expand",
      "spellcheck",
    ];
    attrs.forEach((attr) => {
      node.removeAttribute(attr);
    });
  };
}
